import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Brand } from 'src/models/brand';
import { APIcityService } from 'src/services/api-services/api-city-service';
import { HelperService } from 'src/services/helperService';
import { HistoryService } from 'src/services/historyService';

import { city } from '../../../../../services/api-services/api-interfaces/city.interface';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { TranslateService } from '@ngx-translate/core';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { brands } from 'src/services/api-services/api-interfaces/brands.interface';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { EMPTY } from 'rxjs';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';

@Component({
    selector: 'app-schedule-appointment',
    templateUrl: './schedule-appointment.component.html',
    styleUrls: ['./schedule-appointment.component.sass'],
    standalone: false
})
export class ScheduleAppointmentComponent extends PublicSiteConfigBaseComponent implements OnInit {

  city?:number 
  cities: city[] = []
  cityName:String= ""
  filterType : String= ""
  recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
  utmParams:any = history.state.utmParams as {}
  imagen_banner :any
  brand = {} as Brand;
  webview = {} as Brand;
  brandName=''
  TextForWorkshopScheduleAppointments: string=''
  cities$: Observable<city[]> = new Observable<city[]>();
  brands$: Observable<brands[]> = new Observable <brands[]>()
  areFiltersLoading: boolean = true;
  isLoading: boolean = true;
  chooseServiceWorkshopUrl=''
  chooseServiceUrl=''
  dercoBrand= 0
  emptyschedule: any = {
    adviser: '',
    brand: '',
    clientFirstName: '',
    clientLastName: '',
    contactNumber: '',
    department: '',
    documentNumber: '',
    email: '',
    end: '',
    id: '',
    kilometraje: '',
    legendLabel: '',
    plateNo: '',
    relationVC: '',
    start: '',
    title: '',
    TypeOfDocument: '',
    typeOfService: '',
    vinNo: '',
    workshop: '',
    city: ''
  }
  
  //Validaciones
  ScheduleAppointmentForm = this.formBuilder.group({
    ciudad: ['', Validators.required],
    brand: [''],
  })

  get ciudadControl(): FormControl{
    return this.ScheduleAppointmentForm.get("ciudad") as FormControl;
  }

  constructor(
    public helperService: HelperService,
    public navigation: HistoryService,  
    public customScheduleService: APICustomScheduleService,
    private formBuilder: FormBuilder,
    public cityServiceApi: APIcityService,
    private translate: TranslateService,
    public brandService:APIBrandsService,
    public override publicSiteConfig: PublicSiteConfig,
    private route: ActivatedRoute,
    private router: Router,
  ) { 
      super(publicSiteConfig);
      if(!this.indexbrand || !this.indexCountry){
        this.route.params.subscribe(params => {
          this.indexbrand = params['brand'];
          this.indexCountry = params['country'];
        });
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
        this.router.navigate([bannermanagementURL]);  
      }
      this.chooseServiceUrl=`/WebView/FormWebView/choose-service/${this.indexbrand}/${this.indexCountry}`
      this.chooseServiceWorkshopUrl=`/WebView/FormWebView/choose-service-workshop/${this.indexbrand}/${this.indexCountry}`   
  
  }

  protected override afterConfigLoaded(): void {
    this.imagen_banner = this.CurrentBrand.imagen_banner;

    this.dercoBrand =this.indexbrand

    if(this.indexbrand  != 8){
      this.getCityDataFromService();
      ; 
    }else{
      this.getBrandData()
    }
    
    this.brandName =this.CurrentBrand.name
    this.TextForWorkshopScheduleAppointments= this.translate.instant('TextForWorkshopScheduleAppointment', {
      brandName: this.brandName
    })
  }

  getBrandData(){
    this.isLoading = true
    this.brands$ = this.brandService.getBrandsRetailDerco(Number(this.indexCountry)).pipe(tap({complete: () => (this.isLoading = false)}))
  }

  //validaciones 
  getCityDataFromService(indexbrand?){
  
   
    this.isLoading = true
    //evaluate if another things are selected
    if(this.dercoBrand === 8) {
      this.indexbrand = indexbrand
      this.cities$ = this.customScheduleService.getScheduleDropDownListsWebviewDerco(String(this.helperService.filterType),Number(this.helperService.retailId),this.indexbrand).pipe( tap({
        complete: () => (this.isLoading = false),
      }),catchError((error: any) => {
        if (error.status === 401) { 
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
          this.router.navigate([bannermanagementURL]);
          this.helperService.TokenBooking = '';
        }else{
            // Handle validation error here
          console.error('Validation Error:', error);
          // Rethrow the error to propagate it downstream
          return throwError(() => error); 
        }
        return EMPTY; 
      })
    );
    } 
    else{   this.cities$ = this.customScheduleService.getScheduleDropDownListsWebview(String(this.helperService.filterType),this.indexCountry,this.indexbrand).pipe( tap({
      complete: () => (this.isLoading= false),
    }),catchError((error: any) => {
      if (error.status === 401) { 
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
        this.router.navigate([bannermanagementURL]);
        this.helperService.TokenBooking = '';
      }else{
        // Handle validation error here
      console.error('Validation Error:', error);
      // Rethrow the error to propagate it downstream
      return throwError(error);
      }
      return EMPTY; 
    })
  );} 
  
  }
 
  filterCity(cityName:String){
    this.emptyschedule.city = this.city
    if (this.city)
     { this.cityName = cityName}
  }  
}
